import { Injectable } from '@angular/core';
import { IIDolOloRequestStore } from './iidOlOloRequest.store';
import { IID_OL_OLOREQUEST } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolOloRequestQuery } from './iidOlOloRequest.query'
import { CrudService } from '../crudService';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
@Injectable({
  providedIn: 'root'
})
export class IIDolOloRequestService extends CrudService<IID_OL_OLOREQUEST, IIDolOloRequestStore, IIDolOloRequestQuery> {
  constructor(
    protected store: IIDolOloRequestStore,
    protected query: IIDolOloRequestQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy,
  ) {
    super(
      Topics.IID_OL_OLO_REQUEST,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
